import { render, staticRenderFns } from "./SalesDelivery.vue?vue&type=template&id=a8f8b1e8&scoped=true"
import script from "./SalesDelivery.vue?vue&type=script&lang=js"
export * from "./SalesDelivery.vue?vue&type=script&lang=js"
import style0 from "./SalesDelivery.vue?vue&type=style&index=0&id=a8f8b1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f8b1e8",
  null
  
)

export default component.exports